import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'
import SecureLS from 'secure-ls'
import { setAuthorizationHeader } from 'src/api/userAPI'
import {
  loginHandler,
  logoutSuccess,
  updatePlanSuccess,
  updateShowSideBar,
  updateSuccess,
  updateCompanySuccess,
  updateProfilePicture,
} from './authSlice'

const secureLs = new SecureLS()

const updateStateInStorage = (newState) => {
  secureLs.set('appc-auth-mkplace', newState)
}

const listenerMiddleware = createListenerMiddleware()

const effect = (action, listenerApi) => {
  updateStateInStorage(listenerApi.getState().authReducer.user)
  if (action?.meta?.requestStatus === 'fulfilled') {
    // updateStateInStorage(listenerApi.getState().authReducer.user)
    setAuthorizationHeader(listenerApi.getState().authReducer.user)
  }
}

listenerMiddleware.startListening({
  matcher: isAnyOf(
    loginHandler,
    logoutSuccess,
    updateSuccess,
    updatePlanSuccess,
    updateShowSideBar,
    updateCompanySuccess,
    updateProfilePicture,
  ),
  effect,
})

export default listenerMiddleware.middleware
